import { ElementCoordinate } from '../enums/enums';
import  WindowCoordinates  from './WindowCoordinates';

interface Position {
    top: number,
    right: number,
    left: number, 
    bottom: number,
    height: number,
    width: number
}
interface AvailablePopupPositions {
    [ElementCoordinate.UpperLeft]: boolean,
    [ElementCoordinate.UpperCenter]: boolean,
    [ElementCoordinate.UpperRight]: boolean,
    [ElementCoordinate.CenterLeft]: boolean,
    [ElementCoordinate.CenterRight]: boolean,
    [ElementCoordinate.LowerLeft]: boolean,
    [ElementCoordinate.LowerCenter]: boolean,
    [ElementCoordinate.LowerRight]: boolean,
    [ElementCoordinate.MobileAbove]: boolean,
    [ElementCoordinate.MobileBelow]: boolean
}

class PopupPositions {
    objectClientRect: DOMRect;
    popupClientRect: DOMRect;
    objectClientPosition: { top: number, right: number, left: number, bottom: number, height: number, width: number };//object client rectangle for which the popup is created
    popupClientPosition: { top: number, right: number, left: number, bottom: number, height: number, width: number };//popup client rectangle
    _positions: AvailablePopupPositions;
    objectComputedCSSStyle: CSSStyleDeclaration;

    constructor(objectClientRect: DOMRect, popupClientRect: DOMRect, objectComputedCSSStyle: CSSStyleDeclaration) {
        this.objectClientRect = objectClientRect;		//target HTML elemment client rectangle
        this.popupClientRect = popupClientRect;			//pop-up client rectangle
        this.objectClientPosition = { top: -1, right: -1, left: -1, bottom: -1, height: -1, width: -1 };
        this.popupClientPosition = { top: -1, right: -1, left: -1, bottom: -1, height: -1, width: -1 };
        this._positions = { [ElementCoordinate.UpperLeft]: false, [ElementCoordinate.UpperCenter]: false, [ElementCoordinate.UpperRight]: false, [ElementCoordinate.CenterLeft]: false, [ElementCoordinate.CenterRight]: false, [ElementCoordinate.LowerLeft]: false, [ElementCoordinate.LowerCenter]: false, [ElementCoordinate.LowerRight]: false, [ElementCoordinate.MobileAbove]: false, [ElementCoordinate.MobileBelow]: false };
        this.objectComputedCSSStyle = objectComputedCSSStyle;

        //set position relative to the window
        this.setPosition(this.objectClientRect, this.objectClientPosition);
        this.setPosition(this.popupClientRect, this.popupClientPosition);
        //what positions are valid?
        this.populatePositionValues();
        //return possible pop-up locations
        this.returnAvailablePositions();

    }

    returnAvailablePositions() {
        //return position object
        return this._positions;
    }

    //populate position (uses bounding rect h/w but calculates l/t/r/b using window.scroll x/y)
    // bounding rect is relative to the parent node, not the window!
    setPosition(clientRect: DOMRect, clientPosition: Position) {

        //calc position
        const height = clientRect.height;
        const width = clientRect.width;
        const domElStyle = this.objectComputedCSSStyle;
        let left = clientRect.left;
        let top = clientRect.top;

        //catch for absolutely positions button
        if (domElStyle.position === "absolute") {
            const left = new WindowCoordinates(this.objectClientRect, ElementCoordinate.CenterLeft).getPoint().x;
            const top = new WindowCoordinates(this.objectClientRect, ElementCoordinate.UpperCenter).getPoint().y;
        }

        const bottom = top + height;
        const right = left + width;

        //populate object
        clientPosition.height = height;
        clientPosition.width = width;
        clientPosition.left = left;
        clientPosition.top = top;
        clientPosition.bottom = bottom;
        clientPosition.right = right;
    }

    //helper to populate all position values
    populatePositionValues() {
        this.setULPosition();
        this.setUCPosition();
        this.setURPosition();
        this.setCLPosition();
        this.setCRPosition();
        this.setLLPosition();
        this.setLCPosition();
        this.setLRPosition();
        //mobile above
        this.setMAPosition();
        //mobile below
        this.setMBPosition();
    }

    //individual position value calulations
    //upper left
    setULPosition() {
        const popupLeft = this.objectClientPosition.left - this.popupClientPosition.width;
        const popupTop = this.objectClientPosition.top - this.popupClientPosition.height;
        this._positions.UPPER_LEFT = popupLeft > 0 && popupTop > 0;
    }

    //upper center
    setUCPosition() {
        const popupLeft = this.objectClientPosition.left + (this.objectClientPosition.width * .5) - (this.popupClientPosition.width * .5);
        const popupRight = this.objectClientPosition.left + (this.objectClientPosition.width * .5) + (this.popupClientPosition.width * .5);
        const popupTop = this.objectClientPosition.top - this.popupClientPosition.height;
        this._positions.UPPER_CENTER = popupLeft > 0 && popupTop > 0 && popupRight < window.innerWidth;
    }

    //upper right
    setURPosition() {
        const popupRight = this.objectClientPosition.right + this.popupClientPosition.width;
        const popupTop = this.objectClientPosition.top - this.popupClientPosition.height;
        this._positions.UPPER_RIGHT = popupRight < window.innerWidth && popupTop > 0;
    }

    //center left
    setCLPosition() {
        const popupLeft = this.objectClientPosition.left - this.popupClientPosition.width;
        const popupTop = this.objectClientPosition.top + (this.objectClientPosition.height * .5) - (this.popupClientPosition.height * .5);
        const popupBottom = this.objectClientPosition.top + (this.objectClientPosition.height * .5) + (this.popupClientPosition.height * .5);
        this._positions.CENTER_LEFT = popupLeft > 0 && popupTop > 0 && popupBottom < window.innerHeight;
    }

    //center right
    setCRPosition() {
        const popupRight = this.objectClientPosition.right + this.popupClientPosition.width;
        const popupTop = this.objectClientPosition.top + (this.objectClientPosition.height * .5) - (this.popupClientPosition.height * .5);
        const popupBottom = this.objectClientPosition.top + (this.objectClientPosition.height * .5) + (this.popupClientPosition.height * .5);
        this._positions.CENTER_RIGHT = popupRight < window.innerWidth && popupTop > 0 && popupBottom < window.innerHeight;
    }

    //lower left
    setLLPosition() {
        const popupLeft = this.objectClientPosition.left - this.popupClientPosition.width;
        const popupBottom = this.objectClientPosition.bottom + this.popupClientPosition.height;
        this._positions.LOWER_LEFT = popupLeft > 0 && popupBottom < window.innerHeight;
    }

    //lower center
    setLCPosition() {
        const popupLeft = this.objectClientPosition.left + (this.objectClientPosition.width * .5) - (this.popupClientPosition.width * .5);
        const popupRight = this.objectClientPosition.left + (this.objectClientPosition.width * .5) + (this.popupClientPosition.width * .5);
        const popupBottom = this.objectClientPosition.top + (this.objectClientPosition.height * .5) + (this.popupClientPosition.height * .5);
        this._positions.LOWER_CENTER = popupLeft > 0 && popupRight < window.innerWidth && popupBottom < window.innerHeight;
    }

    //lower right
    setLRPosition() {
        const popupRight = this.objectClientPosition.right + this.popupClientPosition.width;
        const popupBottom = this.objectClientPosition.bottom + this.popupClientPosition.height;
        this._positions.LOWER_RIGHT = popupRight < window.innerWidth && popupBottom < window.innerHeight;
    }

    //mobile above
    setMAPosition() {
        const popupTop = this.objectClientPosition.top - this.popupClientPosition.height;
        this._positions.MOBILE_ABOVE = popupTop > 0;
    }

    //mobile below
    setMBPosition() {
        const popupBottom = this.objectClientPosition.bottom + this.popupClientPosition.height;
        this._positions.MOBILE_BELOW = popupBottom < window.innerHeight;
    }
}
export default PopupPositions;